import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
	.csc-filter-navigation {
    --cse-paper-gap: ${csSpacing.spacing04};
    --cse-selectable-padding-y: ${csSpacing.spacing05};
    --cse-selectable-padding-x: ${csSpacing.spacing05};
	}

	.step-overview-group {
		--cse-selectable-border-radius: var(--csc-filter-navigation-step-border-radius, var(--cse-selectable-border-radius));
	}

	.clear-selection {
		text-align: right;
	}

  .cse-selectable-group {
    --cse-selectable-group-grid-template-columns-y: 1fr;
  }

  .step-text {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
  }
`
